var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pages"}},[(!_vm.videoSubtitle)?_c('App'):_vm._e(),_vm._v(" "),(!_vm.videoSubtitle && _vm.openSubtitle)?_c('AppSubtitle'):_vm._e(),_vm._v(" "),(_vm.$route.subtitle)?_c('VideoSubtitle'):_vm._e(),_vm._v(" "),_c('pagePopupsLayer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5b2bbf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Page.vue
// module id = null
// module chunks = 